// extracted by mini-css-extract-plugin
export var dropdownContainer = "_s8-0";
export var leftAlign = "_s8-4";
export var listItem = "_s8-2";
export var listItemWrapper = "_s8-1";
export var operationText = "_s8-3";